// ** Types
import type { NavGroup, NavLink, NavSectionTitle } from '../types';
import type { NextRouter } from 'next/router';

export const handleURLQueries = (router: NextRouter, path: string | undefined): boolean => {
  if (Object.keys(router.query).length && path) {
    const arr = Object.keys(router.query);

    return (
      router.asPath.includes(path) &&
      router.asPath.includes(router.query[arr[0] || ''] as string) &&
      path !== '/'
    );
  }

  return false;
};

export const hasActiveChild = (
  item: NavLink | NavGroup | NavSectionTitle,
  currentURL: string,
): boolean => {
  const { children } = item as NavGroup;

  if (!children) {
    return false;
  }

  for (const child of children) {
    if ((child as NavGroup).children) {
      if (hasActiveChild(child, currentURL)) {
        return true;
      }
    }
    const childPath = (child as NavLink).path;

    // Check if the child has a link and is active
    if (
      child &&
      childPath &&
      currentURL &&
      (childPath === currentURL || (currentURL.includes(childPath) && childPath !== '/'))
    ) {
      return true;
    }
  }

  return false;
};

export const removeChildren = (
  children: (NavLink | NavGroup | NavSectionTitle)[],
  openGroup: string[],
  currentActiveGroup: string[],
) => {
  children.forEach((child: NavLink | NavGroup | NavSectionTitle) => {
    if (!currentActiveGroup.includes((child as NavLink).title)) {
      const index = openGroup.indexOf((child as NavLink).title);
      if (index > -1) openGroup.splice(index, 1);

      // @ts-expect-error
      if (child.children) removeChildren(child.children, openGroup, currentActiveGroup);
    }
  });
};
